import { Modal } from "antd";
import styled from "styled-components";
import { ModalStyle } from "./modalStyle";

export const ModalComponent = styled(Modal)`
  ${ModalStyle}
`;
